<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label><span class="required">*</span> Nome fantasia</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.nome_fantasia"
                    id="nomeFantasia"
                  />
                </div>
                <div class="col-md-12 mt-1">
                  <label><span class="required">*</span> Razão social</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.razao_social"
                  />
                </div>
                <div class="col-md-3 mt-1">
                  <label><span class="required">*</span> CNPJ</label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'99.999.999./9999-99'"
                    v-model="empresa.cnpj"
                  />
                </div>
                <div class="col-md-3 mt-1">
                  <label><span class="required">*</span> CNES</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.cnes"
                  />
                </div>
                <div class="col-md-2 mt-1">
                  <label
                    ><span class="required">*</span> Telefone/Celular</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'(99) 9999-99999'"
                    v-model="empresa.telefone"
                  />
                </div>
                <div class="col-md-4 mt-1">
                  <label><span class="required">*</span> Email</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.email"
                  />
                </div>
                <div class="col-md-12">
                  <hr />
                </div>
                <div class="col-md-2 mt-1">
                  <label><span class="required">*</span> CEP</label>
                  <input
                    type="text"
                    class="form-control"
                    v-mask="'99999-999'"
                    v-model="empresa.cep"
                    v-on:keyup="buscar"
                  />
                </div>
                <div class="col-md-6 mt-1">
                  <label><span class="required">*</span> Logradouro</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.logradouro"
                  />
                </div>
                <div class="col-md-2 mt-1">
                  <label><span class="required">*</span> Número</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.numero"
                    id="inputNumero"
                  />
                </div>
                <div class="col-md-2 mt-1">
                  <label>Complemento</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.complemento"
                  />
                </div>
                <div class="col-md-4 mt-1">
                  <label><span class="required">*</span> Bairro</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.bairro"
                  />
                </div>
                <div class="col-md-4 mt-1">
                  <label><span class="required">*</span> Cidade</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.cidade"
                  />
                </div>
                <div class="col-md-4 mt-1">
                  <label><span class="required">*</span> Estado</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.estado"
                  />
                </div>
              </div>
              <div class="block text-right">
                <hr />
                <router-link to="/empresas" class="btn btn-back mr-1">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <a class="btn btn-add" @click="save">
                  Salvar <i class="fa fa-save"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      empresa: {
        logradouro: "",
        complemento: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
        cep: "",
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "empresas";

      self.$loading(true);

      if (self.empresa.id) {
        api += "/" + self.empresa.id;
        self.empresa._method = "PUT";
      }

      axios
        .post(api, self.empresa)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/empresas");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.empresa.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.empresa.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.empresa.logradouro = self.endereco.logradouro;
            self.empresa.complemento = self.endereco.complemento;
            self.empresa.bairro = self.endereco.bairro;
            self.empresa.cidade = self.endereco.localidade;
            self.empresa.estado = self.endereco.uf;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getEmpresas: function (id) {
      const self = this;
      const api = self.$store.state.api + "empresas/" + id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.empresa = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
  },
  mounted: function () {
    const self = this;
    $("#nomeFantasia").focus();

    let id = self.$route.params.id;
    if (id) {
      self.getEmpresas(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>